import { useState, useCallback } from 'react';
import { apiClient, FlashcardSet } from '../services';

export const useFlashcardState = () => {
  const [flashcardData, setFlashcardData] = useState<FlashcardSet | null>(null);
  const [isLoadingFlashcards, setIsLoadingFlashcards] = useState(false);
  const [flashcardError, setFlashcardError] = useState<string | null>(null);
  const [flashcardConfigOpen, setFlashcardConfigOpen] = useState(false);

  const generateFlashcards = useCallback(async (fileId: string, numCards: number) => {
    setIsLoadingFlashcards(true);
    setFlashcardError(null);
    setFlashcardConfigOpen(false);

    try {
      const data = await apiClient.generateFlashcardsFromFile(fileId, numCards);
      setFlashcardData(data);
      return data;
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to generate flashcards from file';
      setFlashcardError(errorMessage);
      throw error;
    } finally {
      setIsLoadingFlashcards(false);
    }
  }, []);

  const openFlashcardConfig = useCallback(() => {
    setFlashcardConfigOpen(true);
    setFlashcardError(null);
  }, []);

  const closeFlashcardConfig = useCallback(() => {
    setFlashcardConfigOpen(false);
  }, []);

  const completeFlashcardSession = useCallback(async (ratings: Record<number, string>) => {
    console.log('Flashcard session completed with ratings:', ratings);
    setFlashcardData(null);
  }, []);

  const resetFlashcards = useCallback(() => {
    setFlashcardData(null);
    setFlashcardError(null);
    setFlashcardConfigOpen(false);
  }, []);

  return {
    flashcardData,
    isLoadingFlashcards,
    flashcardError,
    flashcardConfigOpen,
    generateFlashcards,
    openFlashcardConfig,
    closeFlashcardConfig,
    completeFlashcardSession,
    resetFlashcards,
  };
};